import { useEffect, useState } from 'react';
import type { FeatureCollection } from 'geojson';

export function useGeoData() {
  const [zonesData, setZonesData] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    fetch('/data/zones.geojson')
      .then((res) => res.json())
      .then(setZonesData)
      .catch(console.error);
  }, []);

  return { zonesData };
}
